import React from 'react';
import routes from '../constants/routes.json';
import { AnyType } from '~/types';
import { DefaultRunningAnyTile } from './defaultUIComponents';
import { momentDurationToHMin } from '~/utils/timeUtils';
import { useEmployeeId } from '~/state/auth';
import {
  EinmalAuftrag,
  useResumeEinmalAuftrag,
  useRunningEinmalAuftraege,
  useStartEinmalAuftrag,
} from '~/api/EinmalAuftragApi';
import { useNavigate } from 'react-router';

type Props = {
  einmalAuftrag: EinmalAuftrag;
  isStartable?: boolean;
};

const EinmalAuftragTile: React.FC<Props> = ({ einmalAuftrag, isStartable }) => {
  const navigate = useNavigate();
  const employeeId = useEmployeeId();

  const runEinmalAuftragRoute = routes.RUN_EINMAL_AUFTRAG.replace(
    ':einmalAuftrag',
    String(einmalAuftrag.id),
  );

  const onSuccess = () => {
    return navigate(runEinmalAuftragRoute);
  };

  const { data: runningEinmalAuftraege } = useRunningEinmalAuftraege(employeeId);

  const runningEinmalAuftrag = runningEinmalAuftraege?.find(
    (r) => Number(r.einmal_auftrag.id) === Number(einmalAuftrag.id),
  );

  const { mutate: startEinmalAuftrag, isPending: startPending } =
    useStartEinmalAuftrag({ onSuccess });
  const { mutate: resumeEinmalAuftrag, isPending: resumePending } =
    useResumeEinmalAuftrag({ onSuccess });
  const isPending = startPending || resumePending;

  const runEinmalAuftragOnClick = () => {
    if (runningEinmalAuftrag?.status === 'R') {
      return void navigate(runEinmalAuftragRoute);
    }
    if (runningEinmalAuftrag) {
      return resumeEinmalAuftrag({
        runningEinmalAuftragId: Number(runningEinmalAuftrag.id),
      });
    }
    startEinmalAuftrag({ einmalAuftragId: Number(einmalAuftrag.id) });
  };

  return (
    <DefaultRunningAnyTile
      anyType={AnyType.specialJob}
      name={einmalAuftrag.name}
      description={einmalAuftrag.description}
      runRunningAny={runEinmalAuftragOnClick}
      durationString={momentDurationToHMin(einmalAuftrag.duration as unknown as import('moment-timezone').Duration)}
      isStartable={isStartable}
      disabled={isPending}
    />
  );
};

export default EinmalAuftragTile;
